import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';
import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import { copyToClipboard } from '@/utils/vuex';
export default {
  name: 'CoreDtwinShareButtonDialogue',
  components: {
    codemirror
  },
  props: {
    twinId: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return {
      canShareTwin: false,
      showSharingDialog: false,
      isLoadingShareKeyRequest: false,
      existingSharingKey: null,
      urlParams: {
        mapStyleSelect: 4,
        mapStyleItems: [{
          value: 1,
          text: 'Niotix'
        }, {
          value: 2,
          text: 'Satellite'
        }, {
          value: 3,
          text: 'Streets'
        }, {
          value: 4,
          text: 'Combo'
        }],
        markerStyleSelect: 'default',
        markerStyleItems: [{
          value: 'default',
          text: 'Default'
        }, {
          value: 'outlined',
          text: 'Outlined'
        }],
        hidebarSwitch: false,
        indoorSwitch: false,
        pitch: 50,
        bearing: 0,
        zoom: 20,
        clusterdistance: 50,
        zoomlock: false
      },
      positiveNumberRule: val => {
        return val < 0 ? this.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParamsLabels.ruleError') : true;
      }
    };
  },
  computed: {
    ...mapState('app', ['snackbar', 'inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme']),
    n1Protocol() {
      return window.location.protocol.replace(':', '');
    },
    n1Host() {
      return window.location.host;
    },
    cmOptions() {
      return {
        tabSize: 4,
        mode: {
          name: 'text/html',
          json: true
        },
        firstLineNumber: 0,
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: false,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        hintOptions: {
          completeSingle: false
        },
        lineWrapping: true,
        readOnly: true
      };
    },
    dashboardLink() {
      return `${this.n1Protocol}://${this.n1Host}/#/public/${this.existingSharingKey}/tiles/${this.twinId}`;
    },
    dashboardIframeCode() {
      return `<iframe src="${this.dashboardLink}" width="800" height="300"></iframe>`;
    },
    mapLink() {
      const hidebar = this.urlParams.hidebarSwitch ? 'hidebar=true&' : 'hidebar=false&';
      const zoomlock = this.urlParams.zoomlock ? '&zoomlock=true' : '&zoomlock=false';
      const zoom = `&zoom=${this.urlParams.zoom}`;
      const mapstyle = `mapstyle=${this.urlParams.mapStyleSelect}`;
      const clusterdistance = parseInt(this.urlParams.clusterdistance) === 50 ? '' : `&clusterdistance=${this.urlParams.clusterdistance}`;
      return `${this.n1Protocol}://${this.n1Host}/#/public/${this.existingSharingKey}/map/${this.twinId}?${hidebar}${mapstyle}&markerstyle=${this.urlParams.markerStyleSelect.value || this.urlParams.markerStyleSelect}&indoor=${this.urlParams.indoorSwitch}&pitch=${this.urlParams.pitch}&bearing=${this.urlParams.bearing}${clusterdistance}${zoomlock}${zoom}`;
    },
    mapIframeCode() {
      return `<iframe src="${this.mapLink}" width="800" height="300"></iframe>`;
    }
  },
  watch: {
    showSharingDialog() {
      if (this.showSharingDialog) {
        this.findSharingKey();
      }
    },
    twinId() {
      this.requestSharingStatus();
    }
  },
  mounted() {
    this.requestSharingStatus();
  },
  methods: {
    requestSharingStatus() {
      ApiService.digitalTwinCanShare(this, this.twinId).then(res => {
        this.canShareTwin = res.canShare;
      }).catch(error => {
        console.error(error);
      });
    },
    findSharingKey() {
      this.isLoadingShareKeyRequest = true;
      ApiService.digitalTwinFindExistingShareKey(this, this.twinId).then(res => {
        this.existingSharingKey = res;
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.isLoadingShareKeyRequest = false;
      });
    },
    shareTwin() {
      this.isLoadingShareKeyRequest = true;
      ApiService.digitalTwinCreateShareKey(this, this.twinId).then(res => {
        this.existingSharingKey = res;
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.isLoadingShareKeyRequest = false;
      });
    },
    unshareTwin() {
      this.isLoadingShareKeyRequest = true;
      ApiService.digitalTwinDeleteShareKey(this, this.twinId).then(() => {
        this.existingSharingKey = null;
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.isLoadingShareKeyRequest = false;
      });
    },
    refreshForm() {
      setTimeout(() => {
        // required workaround to get the cursor appearing at the right spot
        // https://discuss.codemirror.net/t/codemirror-cursor-is-not-partially-visible/648/6
        this.$refs.codemirror.codemirror.refresh();
        this.$refs.codemirror.codemirror.focus();
      }, 50);
    },
    onCmFocus() {
      this.refreshForm();
    },
    copyToClipboard(event, copyValue) {
      event.stopPropagation();
      copyToClipboard(copyValue);
    }
  }
};